module.exports = __webpack_public_path__ + "img/agendamento.dede4414.png";